import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormikCheckbox } from 'components';
import { useMeta } from 'hooks';
import { TranslationNamespace } from 'i18n';

export const DeepLinkPaymentPageSetting: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });
  const {
    isUseDeepLinkPaymentPageSettingEnabled,
    isIncludeDeeplinkInResponseAllowed,
  } = useMeta();

  return (
    <>
      {isUseDeepLinkPaymentPageSettingEnabled && (
        <FormikCheckbox
          name="useDeepLinkPaymentPage"
          label={t('fields.use_deep_link_payment_page')}
          helperText={t('fields.use_deep_link_payment_page_helper')}
        />
      )}
      {isIncludeDeeplinkInResponseAllowed && (
        <FormikCheckbox
          name="includeDeeplinkInResponse"
          label={t('fields.include_deeplink_in_response')}
          helperText={t('fields.include_deeplink_in_response_helper')}
        />
      )}
    </>
  );
};
